import { Loading, LoadingContainer, LoadingWrapper } from "./Components"

export const DataTableLoading = () => {
    return (
        <LoadingContainer>
            <LoadingWrapper>
                <Loading>
                    <span></span>
                </Loading>
            </LoadingWrapper>
            
        </LoadingContainer>
    )
}